import { render, staticRenderFns } from "./FormSectionTitle.vue?vue&type=template&id=68f38cd6&"
import script from "./FormSectionTitle.vue?vue&type=script&lang=js&"
export * from "./FormSectionTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports